export default function snakeCaseToCamelCase(text) {
  return text.split('_')
    .map(word => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
